const PuzzleLocation = {};
export default PuzzleLocation;

PuzzleLocation.BANK_FROM = "BANK_FROM";
PuzzleLocation.BANK_TO = "BANK_TO";
PuzzleLocation.BOAT = "BOAT";

PuzzleLocation.ALL = [PuzzleLocation.BANK_FROM, PuzzleLocation.BOAT, PuzzleLocation.BANK_TO];